/* eslint-disable class-methods-use-this */
import * as api from '../../../utils/apiClient';

class CouponsService {
  async activatedCoupon(state, body) {
    const response = await api.post('/coupons/activated-coupon', {}, body);
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new CouponsService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/coupons/services/CouponsService.js